var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 5H13","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9 1L13 5L9 9","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowInline.defaultProps = {"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
